import {Action, createReducer, on} from '@ngrx/store';
import {initialStorageState, StorageState} from '../state/storage.state';
import {
  deleteTokens, setAccessExpire, setAPIConfig, setAPIEndpoint, setEntryPoint, setInjectionToken, setListConfig,
  setRefreshExpire, setScopes,
  userId
} from '../actions/storage.action';

export const initialState: StorageState = initialStorageState();

const StorageReducer = createReducer(
  initialState,
  on(setAPIConfig, (state: StorageState, {config}): StorageState => {
      return {
        ...state,
        APIConfig: config
      }
    }
  ),
  on(setAPIEndpoint, (state: StorageState, {endpoint}): StorageState => {
      return {
        ...state,
        APIEndpoint: endpoint
      }
    }
  ),
  on(setInjectionToken, (state: StorageState, {token, expiredIn}): StorageState => {
      return {
        ...state,
        tokens: {
          access: {
            injectionToken: token,
            expiredIn,
            createdTimestampInSeconds: Date.now() / 1000
          },
          refresh: null
        }
      }
    }
  ),

  on(setAccessExpire, (state: StorageState, {expiredIn}): StorageState => {
      return {
        ...state,
        tokens: {
          refresh: state.tokens.refresh,
          access: {
            expiredIn: expiredIn,
            createdTimestampInSeconds: Date.now() / 1000
          }
        }
      }
    }
  ),
  on(setRefreshExpire, (state: StorageState, {expiredIn}): StorageState => {
      return {
        ...state,
        tokens: {
          access: state.tokens.access,
          refresh: {
            expiredIn: expiredIn,
            createdTimestampInSeconds: Date.now() / 1000
          }
        }
      }
    }
  ),

  on(deleteTokens, (state: StorageState): StorageState => {
      return {
        ...state,
        tokens: {
          access: null,
          refresh: null
        }
      }
    }
  ),
  on(userId, (state: StorageState, {userId}): StorageState => {
      return {
        ...state,
        userId
      }
    }
  ),
  on(setEntryPoint, (state: StorageState, {entryPoint}): StorageState => {
      return {
        ...state,
        entryPoint
      }
    }
  ),
  on(setScopes, (state: StorageState, {scopes}): StorageState => {
      return {
        ...state,
        scopes
      }
    }
  ),

  on(setListConfig, (state: StorageState, {id, visibleColumnFields}): StorageState => {
    let listConfigs = state.listConfigs.filter(l => l.id != id)
    listConfigs.push({id, visibleColumnFields});
    return {
      ...state,
      listConfigs
    }
  })
);

export function reducer(state: StorageState | undefined, action: Action) {
  return StorageReducer(state, action);
}
